import { setNotification } from "./../actions/notificationActions";
import { takeLatest, put, call } from "redux-saga/effects";
import { delay } from "redux-saga";
import { navigate } from "@reach/router";
import {
  AUTH,
  USER_SIGNIN,
  USER_SIGNOUT,
  USER_SIGNOUT_SUCCESS,
  USER_FORGOT_PASSWORD,
  AUTH_ACTIONS
} from "./../actions/authActions";
import {
  logout,
  forgotPassword,
  authorize,
  checkDbStatus,
  checkLocalStorageStatus,
  watchDbStatus,
  watchingFrequencyTime
} from "./../../firebase";

import { Auth_ERRORS, isContinued } from "./constants";
import { setError, removeError } from "./../actions/authActions";

var unAutorized;
var alreadyLogedIn;
var suspect;
var signedOut;
function* userSignIn(action) {
  const { payload } = action;
  try {
    //yield call(login, payload);
    yield call(authorize, payload);
    alreadyLogedIn = yield call(checkDbStatus, null);
    console.log("error ", alreadyLogedIn);
    // if user already loged in
    if (alreadyLogedIn) {
      localStorage.setItem("email", payload.email);
      console.log(" before setting error ");
      yield put(setError(Auth_ERRORS.ALREADY_LOGER_IN));
      var c = 0; // waiting for response
      outer: while (true) {
        c++;
        console.log(" in continued ", isContinued);
        if (isContinued) {
          // we need to wait at least 11s  .. to complete force login()
          yield delay(watchingFrequencyTime + 5000);
          while (true) {
            const suspect = yield call(watchDbStatus, null);
            if (suspect) {
              yield put(setError(Auth_ERRORS.SUSPECT));
              break outer;
            }
            if (suspect || unAutorized || signedOut) break outer;
            yield delay(watchingFrequencyTime); // watching for every 10s
          }
        }
        if (isContinued === false) {
          break;
        }
        yield delay(2000);
        if (c === 10) {
          yield put(removeError()); // after 20 seconds removing Dialog
          break;
        }
      }
    } else {
      navigate("/main");

      while (true) {
        suspect = yield call(watchDbStatus, null);
        console.log(" suspect ", suspect);

        if (suspect) {
          yield put(setError(Auth_ERRORS.SUSPECT));
          break;
        }
        if (suspect || unAutorized || signedOut) break;
        yield delay(watchingFrequencyTime);
      }
    }
  } catch (error) {
    console.log("error in authMiddleware() ", error.toString());
    yield put(setNotification({ message: error.message, resource: AUTH }));
  }
}

function* userSignOut(action) {
  try {
    signedOut = true;
    yield call(logout);
    yield put({
      type: USER_SIGNOUT_SUCCESS
    });
    yield put(
      setNotification({ message: "Logged out Successfully", resource: AUTH })
    );
    navigate("/login");
  } catch (error) {
    yield put(setNotification({ message: error.message, resource: AUTH }));
  }
}

function* userForgotPassword(action) {
  const { payload } = action;
  try {
    yield call(forgotPassword, payload);
    yield put(
      setNotification({
        message: "Password reset email sent, check your inbox",
        resource: AUTH
      })
    );
    navigate("/login");
    // yield call(redirectTo, "/login");
  } catch (error) {
    var errorCode = error.code;
    if (errorCode === "auth/invalid-email") {
      yield put(
        setNotification({
          message: "Please enter valid email address",
          resource: AUTH
        })
      );
    } else if (errorCode === "auth/user-not-found") {
      yield put(
        setNotification({
          message:
            "Your not authorized to access this domain." +
            "Please contact support@uttarainfo.com",
          resource: AUTH
        })
      );
    } else {
      yield put(setNotification({ message: error.message, resource: AUTH }));
    }
  }
}

export function* checkAuthStatus() {
  unAutorized = yield call(checkLocalStorageStatus, null);
  console.log(" checkAuthStatus in ", unAutorized);
  if (unAutorized) {
    yield put(setError(Auth_ERRORS.UN_AUTHORIZED));
    navigate("/");
  }
}

export default function* authWatcher() {
  yield takeLatest(USER_SIGNIN, userSignIn);
  yield takeLatest(USER_SIGNOUT, userSignOut);
  yield takeLatest(USER_FORGOT_PASSWORD, userForgotPassword);
  yield takeLatest(AUTH_ACTIONS.AUTHENTICATE, checkAuthStatus);
}



// WEBPACK FOOTER //
// ./src/redux/middleware/authMiddleware.js